module.exports = __webpack_public_path__ + "static/plane-e2bf46cc809d04e85a8fd05c397c169b.svg";